<template>
  <div class="search-wrapper">
    <div v-if="isDesktop" class="search-bar-static" @click="showModal = true">
      <i class="fas fa-search"></i>
      <span>Search other funds</span>
    </div>

    <div v-else class="input-wrapper">
      <i class="fas fa-search search-icon"></i>
      <input
        v-model="searchQuery"
        type="text"
        class="search-input"
        style="width: 108%"
        placeholder="Search other funds"
        @focus="isTyping = true"
        @blur="handleBlur"
      />
      <ul
        v-if="searchQuery.trim() && filteredSchemes.length && isTyping"
        class="search-results"
      >
        <li
          v-for="scheme in filteredSchemes"
          :key="scheme.schemecode"
          class="list-group-item"
          @mousedown.prevent="selectScheme(scheme)"
        >
          {{ scheme.schemename }}
        </li>
      </ul>
    </div>

    <div
      v-if="isDesktop && showModal"
      class="modal-overlay"
      @click.self="showModal = false"
    >
      <div class="modal-content">
        <div class="modal-header">
          <span>Search other funds</span>
          <button class="close-btn" @click="showModal = false">&times;</button>
        </div>
        <div class="input-wrapper">
          <i class="fas fa-search search-icon"></i>
          <input
            v-model="searchQuery"
            type="text"
            class="search-input"
            style="width: 100%"
            placeholder="Search other funds"
            @focus="isTyping = true"
            @blur="handleBlur"
          />
          <ul
            v-if="searchQuery.trim() && filteredSchemes.length && isTyping"
            class="search-results"
          >
            <li
              v-for="scheme in filteredSchemes"
              :key="scheme.schemecode"
              class="list-group-item"
              @mousedown.prevent="selectScheme(scheme)"
            >
              {{ scheme.schemename }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: '',
      schemes: [],
      isTyping: false,
      isDesktop: window.innerWidth >= 768,
      showModal: false,
    }
  },
  computed: {
    filteredSchemes() {
      const q = this.searchQuery.toLowerCase()
      return this.schemes.filter((s) => s.schemename.toLowerCase().includes(q))
    },
  },
  mounted() {
    this.loadSchemes()
    window.addEventListener('resize', this.checkViewport)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkViewport)
  },
  methods: {
    checkViewport() {
      this.isDesktop = window.innerWidth >= 768
    },
    handleBlur() {
      setTimeout(() => {
        this.isTyping = false
      }, 150)
    },
    selectScheme(scheme) {
       this.searchQuery = ''
       this.isTyping = false
       if (this.isDesktop) this.showModal = false
       const cleanedName = scheme.schemename
       .replace(/-?\([^)]*\)/gi, '')      
       .replace(/direct\s*plan/gi, '')   
       .replace(/regular\s*plan/gi, '')  
       .trim()
       const schemeSlug = cleanedName
         .toLowerCase()
         .replace(/[^a-z0-9\s-]/g, '')      
         .replace(/\s+/g, '-')               
         .replace(/-+/g, '-')                
         .trim()
       const url = (process.env.VUE_APP_BASE_URL || '') +
        `/mutual-funds/fund/${schemeSlug}/${scheme.schemecode}`

       window.open(url, '_blank')
     },
    async loadSchemes() {
      const cached = sessionStorage.getItem('schemeListCache')
      if (cached) {
        this.schemes = JSON.parse(cached)
      } else {
        try {
          const url =
            (process.env.VUE_APP_BASE_URL || '') +
            '/schemes_list_member_view.json'
          const res = await fetch(url)
          const data = await res.json()
          if (data?.schemes) {
            this.schemes = data.schemes
            sessionStorage.setItem(
              'schemeListCache',
              JSON.stringify(data.schemes)
            )
          }
        } catch (e) {
          console.error(e)
        }
      }
    },
  },
}
</script>

<style scoped>
.search-wrapper {
  max-width: 500px;
  position: relative;
}

@media (max-width: 767px) {
  .search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

.search-bar-static {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.search-bar-static i {
  margin-right: 8px;
  color: #888;
}

.input-wrapper {
  position: relative;
}
.search-input {
  
  padding: 10px 15px 10px 35px;
  border: 1px solid #ccc;
  border-radius: 10px;
}
.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  pointer-events: none;
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 0 0 10px 10px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 2px;
}
.list-group-item {
  padding: 10px;
  cursor: pointer;
}
.list-group-item:hover {
  background: #f1f1f1;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-content {
  width: 90%;
  max-width: 500px;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #888;
}
</style>
